import { useBunja } from 'bunja/react';
import { useAtomValue } from 'jotai';

import { FormattedMessage } from '@flipster/i18n';
import CautionCircleIcon from '@flipster/react/icon/generated/CautionCircleIcon';
import { css } from '@flipster/styled-system/css';
import { hstack } from '@flipster/styled-system/patterns';
import { token } from '@flipster/styled-system/tokens';
import { UsdtCurrency, UsdtPrecision } from '@flipster/utils/constants/currency';
import Num, { numberFormatter } from '@flipster/utils/num';

import { copyTradingSettingsBunja } from '../state';

export const AvailableAmountLimitWarning = () => {
  const { portfolioAtom } = useBunja(copyTradingSettingsBunja);
  const portfolio = useAtomValue(portfolioAtom);
  if (!portfolio) return null;
  if (Num(portfolio.availableInvestmentAmountUsdt).gt(portfolio.maxInvestAmountUsdt)) return null;
  return (
    <div className={hstack({ gap: 8, p: 8, rounded: 8, bg: 'background.state.warning.tint' })}>
      <CautionCircleIcon size={16} color={token('colors.content.state.warning')} />
      <p className={css({ textStyle: 'Text/M/Regular', color: 'content.default.level-3' })}>
        <FormattedMessage
          id='Copy.r251107.Copy_limit_almost_full_symbol_amount_left_only'
          values={{
            symbolAmount: `${numberFormatter(portfolio.availableInvestmentAmountUsdt, { precision: UsdtPrecision })} ${UsdtCurrency}`,
          }}
        />
      </p>
    </div>
  );
};
